import { TweenLite } from 'gsap';
import { getGameSize, IGameSizeInfo, MapList } from '../../Config/Levels';
import { gameConfig } from '../../index';
import { HudActions, HudEmitter } from '../../Managers/Hud/HudEmitter';
import { Popup } from '../../Managers/Popups';
import MapGateList from '../Map/MapGateList';
import { CharacterPopup } from './CharacterPopup';
import { waitForMs } from '../../Utils/AsyncUtils';

export class MapGatePopup extends CharacterPopup {
    private readonly overlay: PIXI.Sprite;
    private ids: string[];
    private mapGateList: MapGateList;

    constructor(mapList: string[]) {
        super(
            gameConfig.game_width * 0.85,
            gameConfig.game_height * 0.65,
            'character/character-default',
            'whereto',
            Popup.MAPGATE
        );

        const gameSize: IGameSizeInfo = getGameSize();

        const overlay = new PIXI.Sprite(PIXI.utils.TextureCache['loading/win-bg']);
        let bScale = gameSize.gameWidth / overlay.width;
        if (overlay.height * bScale < gameSize.gameHeight) {
            bScale = gameSize.gameHeight / overlay.height;
        }
        overlay.scale.set(bScale);
        this.x = (gameSize.gameWidth - this.bg.width) / 2;

        overlay.alpha = 0;
        overlay.interactive = true;
        this.ids = mapList;
        this.overlay = overlay;
    }

    public async tweenIn() {
        //@ts-ignore
        this.parent.addChild(this.overlay, this);
        TweenLite.to(this.overlay, 0.2, {
            alpha: 1,
        });
        super.tweenIn();
        this.showGateList();
    }

    public showGateList(newAddition: boolean = false) {
        const mapIds = [...MapList].reverse().reduce((acc, current) => {
            if (this.ids.indexOf(current) !== -1) {
                acc.push(current);
            }
            return acc;
        }, []);

        const width = gameConfig.game_width * 0.85;
        let height = gameConfig.game_height * 0.77;
        const heightDifference = 0.4 * height;
        height -= heightDifference;
        const list = new MapGateList(mapIds, this.handleMapButton.bind(this), width, height);
        list.x = 0;
        list.y = 0.47 * heightDifference;
        this.addChild(list);
        list.tweenIn(newAddition);
        this.mapGateList = list;
    }

    public tweenOut() {
        TweenLite.to(this.overlay, 0.2, {
            alpha: 0,
            onComplete: () => {
                this.overlay.destroy();
            },
        });
        waitForMs(100).then(() => super.tweenOut());
    }

    private handleMapButton(id: string) {
        this.mapGateList.removeListeners();
        HudEmitter.instance.emit(HudActions.CLOSE_POPUP, Popup.MAPGATE, 0, id);
    }
}
